import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicComponent } from '@references/public/public.component';
import { PublicGuard } from '@shared/guards/public.guard';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'forget',
        loadChildren: () =>
          import('@references/public/forget/forget.module').then(
            (m) => m.ForgetModule
          )
      },
      {
        path: 'login',
        canActivate: [PublicGuard],
        loadChildren: () =>
          import('@references/public/login/login.module').then(
            (m) => m.LoginModule
          ),
        data: {
          preload: true
        }
      },
      {
        path: 'references/:id',
        loadChildren: () =>
          import('@references/public/references/references.module').then(
            (m) => m.ReferencesModule
          ),
        data: {
          preload: true
        }
      },
      {
        path: 'reference-requests/:id',
        loadChildren: () =>
          import(
            '@references/public/reference-requests/reference-requests.module'
          ).then((m) => m.ReferenceRequestsModule),
        data: {
          preload: true
        }
      },
      {
        path: 'reset/:id',
        loadChildren: () =>
          import('@references/public/reset/reset.module').then(
            (m) => m.ResetModule
          )
      },
      {
        path: 'verification-requests/:id',
        loadChildren: () =>
          import(
            '@references/public/verification-requests/verification-requests.module'
          ).then((m) => m.VerificationRequestsModule),
        data: {
          preload: true
        }
      },
      {
        path: 'permissions/:id',
        loadChildren: () =>
          import('@references/public/permissions/permissions.module').then(
            (m) => m.PermissionsModule
          )
      },
      {
        path: 'signatures/:id',
        loadChildren: () =>
          import('@references/public/signatures/signatures.module').then(
            (m) => m.SignaturesModule
          )
      },
      {
        path: 'forms/:id',
        loadChildren: () =>
          import('@references/public/forms/forms.module').then(
            (m) => m.FormsModule
          )
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule {}
